import { COMPANY } from '@constants/index';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer
      className="px-8 py-12 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4 flex-wrap"
      aria-label="Footer"
    >
      <Logo />
      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-center">
        <p className="font-sans text-label text-text-muted tracking-label uppercase">
          © {COMPANY.YEAR} {COMPANY.NAME}
        </p>
        <p className="font-sans text-label text-text-faint tracking-wide uppercase">
          Strictly Private & Confidential | For Information Purposes Only
        </p>
      </div>
    </footer>
  );
}